const MONGO_DB_WRITE_CONFLICT_MESSAGE =
  'Write conflict during plan execution and yielding is disabled';

const MONGO_DB_PLEASE_RETRY_MESSAGE =
  'Please retry your operation or multi-document transaction';

export const checkIfIsTransactionConflictError = (error: unknown) =>
  error instanceof Error &&
  (error.message.includes(MONGO_DB_WRITE_CONFLICT_MESSAGE) ||
    error.message.includes(MONGO_DB_PLEASE_RETRY_MESSAGE));
